import { Component } from "@angular/core";

@Component({
    selector: 'app-tax-by-service',
    templateUrl: './taxbyservice.component.html',
    styleUrls: ['./taxbyservice.component.css']
})

export class TaxByService{

}